import gql from "graphql-tag";

const GET_NOTE_ATTACHMENT = gql`
  query getNoteAttachment($input: NoteAttachmentInformation) {
    getNoteAttachment(input: $input)
  }
`;
export default GET_NOTE_ATTACHMENT;
